import React from 'react'
import Navbar from '../MainComponents/Navbar'
import Footer from '../MainComponents/Footer'
import { Link } from 'react-router-dom'
import { FiHome, FiAlertTriangle, FiArrowLeft } from 'react-icons/fi'
import errorimg from '../../Assets/error.png'
import { useTranslation } from 'react-i18next'
import './error.css'

function ErrorPage() {
  const { t } = useTranslation()
  return (
    <div className="error-page-wrapper">
        <Navbar />
        <div className="error-container">
          <div className="error-glow-1"></div>
          <div className="error-glow-2"></div>
          
          <div className="error-card">
            <div className="error-badge">
              <FiAlertTriangle className="badge-icon" />
              <span>{t('error.error404')}</span>
            </div>
            
            <div className="error-image-wrapper">
              <img src={errorimg} alt="404 Error Illustration" className="error-image" />
            </div>

            <h1 className="error-title">{t('error.pageNotFound')}</h1>
            <p className="error-message">
              {t('error.errorMessage')}
            </p>

            <div className="error-actions">
              <Link to="/" className="btn-primary">
                <FiHome className="btn-icon" />
                <span>{t('error.backToHome')}</span>
              </Link>
              <button onClick={() => window.history.back()} className="btn-secondary">
                <FiArrowLeft className="btn-icon" />
                <span>{t('error.goBack')}</span>
              </button>
            </div>
          </div>
        </div>
        <Footer />
    </div>
  )
}

export default ErrorPage